import React from 'react';

import './CheckBoxCell.scss';

interface ICheckBoxCell {
  value?: any;
  isChecked?: boolean;
  isDisabled?: boolean;
  callback?: Function;
}

export const CheckBoxCell: React.FC<ICheckBoxCell> = ({
  value = {},
  isChecked: checked = false,
  isDisabled = false,
  callback,
}) => {
  const [isChecked, setIsChecked] = React.useState<boolean>(checked);

  const handleChange = () => {
    setIsChecked(!isChecked);
    if (callback) {
      callback(value);
    }
  };

  return (
    <td className='input-cell select-download'>
      <input
        type='checkbox'
        disabled={isDisabled}
        checked={isChecked}
        onChange={() => handleChange()}
      />
    </td>
  );
};
